import { useGetCruises } from 'api-hooks/cruise';
import { NavigationRoutes } from 'common/constants';
import useGetCrudPermission from 'hooks/use-get-crud-permission';
import useGetListParamsValue from 'hooks/use-get-list-params-value';
import Text from 'mantine-components/widget/text';
import useTranslation from 'next-translate/useTranslation';
import React from 'react';
import UniskaiListTemplate from 'templates/list/uniskai-list-template';

export default function CruiseList() {
  const { t } = useTranslation();
  const { queryPage } = useGetListParamsValue();
  const [page, setPage] = React.useState(queryPage);

  const permission = useGetCrudPermission('cruises');

  const _columns = React.useMemo(
    () => [
      {
        header: t('common:code'),
        accessorKey: 'code',
        minSize: 100,
        sortName: 'code',
      },
      {
        header: t('common:airline'),
        accessorKey: 'name',
        minSize: 250,
        sortName: 'name',
      },
      {
        header: t('common:address'),
        accessorKey: 'address',
        minSize: 250,
        sortName: 'address',
      },

      {
        header: t('common:email'),
        accessorKey: 'email',
        minSize: 180,
      },
      {
        header: t('cruise:tel_phone'),
        accessorKey: 'phone',
        minSize: 180,
      },
      {
        header: t('cruise:cellphone_number'),
        accessorKey: 'phone_2',
        minSize: 180,
      },
      {
        header: t('cruise:contact_person'),
        accessorKey: 'contact',
        minSize: 250,
        cell: ({ row }) => {
          const { original } = row;
          const contact = original.contact;

          return (
            <>
              <Text variant="paragraphSmall">
                {t('common:name')}: {contact?.name || '-'}
              </Text>
              <Text variant="paragraphSmall">
                {t('common:description')}: {contact?.description || '-'}
              </Text>
            </>
          );
        },
      },
    ],
    [t],
  );

  return (
    <UniskaiListTemplate
      title={t(`pathname:${NavigationRoutes.CruisesList}`)}
      columns={_columns}
      page={page}
      setPage={setPage}
      useQuery={useGetCruises}
      queryInput={{
        params: {
          page,
        },
      }}
      tableName={NavigationRoutes.CruisesList}
      addNavigation={NavigationRoutes.CruisesCreate}
      rowLink={
        permission?.view
          ? (row) => ({
              pathname: NavigationRoutes.CruisesView,
              query: { id: row.original.id },
            })
          : undefined
      }
    />
  );
}
